import { EMPTY_VALUE } from '@/constants/ui'
import { DirtyFieldChange } from '@/hooks'
import { formatDateOnly } from '@/utils/date'

export const computeKeylessArrayDiff = (
  initialIds: string[],
  currentIds: string[],
  label: string,
  getName: (id: string) => string,
): DirtyFieldChange | null => {
  const initialSet = new Set(initialIds)
  const currentSet = new Set(currentIds)
  const prevItems = initialIds.map((id) => ({ removed: !currentSet.has(id), value: getName(id) }))
  const nextItems = currentIds.map((id) => ({ added: !initialSet.has(id), value: getName(id) }))
  if (!prevItems.some((i) => i.removed) && !nextItems.some((i) => i.added)) return null
  return { arrayDiff: { nextItems, prevItems }, label, nextValue: '', prevValue: '' }
}

export const computeKeylessDateDiff = (
  initialDate: Date | null,
  currentDate: Date | null,
  label: string,
): DirtyFieldChange | null => {
  const prevValue = initialDate ? formatDateOnly(initialDate) : EMPTY_VALUE
  const nextValue = currentDate ? formatDateOnly(currentDate) : EMPTY_VALUE
  if (prevValue === nextValue) return null
  return { label, nextValue, prevValue }
}
